import { useCallback } from 'react'

import { F0ButtonToggle } from '@factorialco/f0-react'
import { Microphone, MicrophoneNegative } from '@factorialco/f0-react/icons/app'
import { useLocalParticipant, usePersistentUserChoices } from '@livekit/components-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const MicrophoneButton = () => {
  const { saveAudioInputEnabled } = usePersistentUserChoices()
  const { localParticipant } = useLocalParticipant()
  const audioEnabled = localParticipant.isMicrophoneEnabled

  const handleMicToggle = useCallback(
    async (selected: boolean) => {
      try {
        await localParticipant.setMicrophoneEnabled(selected)
        saveAudioInputEnabled(selected)
      } catch (error) {}
    },
    [localParticipant, saveAudioInputEnabled]
  )

  return (
    <F0ButtonToggle
      icon={audioEnabled ? Microphone : MicrophoneNegative}
      label={i18n.t('common.ai.voice.control_bar.microphone.label')}
      onSelectedChange={(selected: boolean) => {
        track(trackingEvents.meetings.ControlBarMuteButton, {
          isMuted: !selected,
        })
        handleMicToggle(selected)
      }}
      size="md"
      selected={audioEnabled}
    />
  )
}
